import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import _ from "lodash";
import { sendAsync } from "../../../app/applicationSlice";
import { RootState, RootThunkApi } from "../../../app/store";
import {
  DateRangeFieldName,
  DateRangeType,
  getDateRange,
} from "../../../compnents/form/DateSelect";
import { DoctorSalesResult, fromJson } from "../../../models/doctorSales";
import * as service from "../../../services/doctorSales";
import { GetDoctorSaleEntriesParams } from "../../../services/doctorSales";

interface DoctorSalesState {
  params: GetDoctorSaleEntriesParams;
}

const [timeHead, timeTail] = getDateRange(DateRangeType.ThisMonth);

const initialState = {
  params: {
    timeHead,
    timeTail,
    [DateRangeFieldName]: DateRangeType.ThisMonth,
  },
} as DoctorSalesState;

const doctorSaleSlice = createSlice({
  name: "drugCostSlice",
  initialState,
  reducers: {
    setGetDoctorSaleEntriesParams: (
      state,
      action: PayloadAction<Partial<GetDoctorSaleEntriesParams>>
    ) => {
      state.params = { ...state.params, ...action.payload };
    },
  },
});

export const { setGetDoctorSaleEntriesParams } = doctorSaleSlice.actions;

export const selectGetDoctorSaleEntriesParams = (
  state: RootState
): GetDoctorSaleEntriesParams => state.doctorSale.params;

export const getDoctorSaleEntries = createAsyncThunk<
  DoctorSalesResult,
  GetDoctorSaleEntriesParams,
  RootThunkApi<DoctorSalesResult>
>("doctorSales/getDoctorSaleEntriesStatus", async (params, api) => {
  return sendAsync(service.getDoctorSale(params), api).then((data) => {
    return {
      headers: data.headerList || [],
      entries:
        _.chain(data.allDoctorSaleList)
          .map((e) => fromJson(e))
          .value() || [],
    };
  });
});

export default doctorSaleSlice.reducer;
